<template>
  <ul :class="[$style.container, { [$style.narrow]: narrow }]">
    <slot />
  </ul>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'PointList',
  props: {
    narrow: {
      type: Boolean,
      default: false,
    },
  },
});
</script>

<style lang="scss" module>
.container > li {
  @include font(13, regular, description);
  font-size: inherit; /* override */
  list-style: disc;
  margin-left: 1.5em;

  &:not(:last-child) {
    margin-bottom: 8px;
  }
}

.container.narrow > li {
  &:not(:last-child) {
    margin-bottom: 4px;
  }
}
</style>
